import { axios } from '@Api/axiosClient';
import type { VerifyDeviceResponse } from '@Types/deviceAuth.interface';

export const verifyDeviceApi = async (): Promise<VerifyDeviceResponse> => {
    const response = await axios.post<VerifyDeviceResponse>(
        '/api/DeviceAuth/VerifyDevice'
    );
    return response.data;
};
